/*
 * @Description: 城市专场
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-08 12:09:39
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-15 21:19:44
 */
import React, { useState, useEffect } from 'react' ;
import SelfCity from './selfCity' ;
import { Pagination } from 'antd';
import { cityList } from '../../util/api' ;
import { getCid } from '../../util/helper' ;
import { Log } from '../../util/empty' ;


const  List = [
  {
    id : 1 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 2 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 3 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 4 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 5 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
  {
    id : 6 ,
    logo : "https://pic2.58cdn.com.cn/m1/bigimage/n_v2daf907fe939245db99476002601100c4.jpg" ,
    name : "北京" ,
  },
]

const CurCityBlock = () => {
  const [data, setData] = useState({});
  const [page_no, setPage] = useState(1) ;
  const page_size = 20 ;
  
  let temp = decodeURI(window.location.hash).split(":")[1];
  let city = temp.length > 0 ? temp.split("_")[0] : getCid() ;
  
  useEffect( async () => {
    let res = await cityList(city,page_no, page_size) ;
    setData(res);
    // console.log('pageeee',res) ;
    Log(`cfCityPageShow_${city}`) ;
  },[]);

  const onchange = async (page_no) => {
    // console.log("++++page",page_no,page_size);
    setPage(page_no);
    let res = await cityList(city,page_no, page_size) ;
    // console.log('pageeeee',data,data.list);
    setData(res);
  }
  
  return(
    Object.keys(data).length > 0 ?
    <div className="curcity-block">
      <div className="curcity-block-title"></div>
      <div className="curcity-block-content">
        {
          data.list.map((item, index) => {
            // console.log(data.list.length);
            return (
              <SelfCity data={item} key={item.id}/>
            )
          })
        }
      </div>
      <Pagination 
        total={data.total} 
        size="small" 
        onChange={onchange}
        defaultPageSize={20}
        pageSize={20}
      />
    </div>
    : ""
  )
}

export default CurCityBlock ;